import React from "react";
import PropTypes from "prop-types";
import { createGlobalStyle } from "styled-components";
var GlobalStyle = createGlobalStyle(["@font-face{font-family:'Museo-Sans';font-display:swap;src:url('https://assets.reastatic.net/common/museo-sans-300-v1.woff2') format('woff2'),url('https://assets.reastatic.net/common/museo-sans-300-v1.woff') format('woff');font-weight:300;}@font-face{font-family:'Museo-Sans';font-display:swap;src:url('https://assets.reastatic.net/common/museo-sans-500-v1.woff2') format('woff2'),url('https://assets.reastatic.net/common/museo-sans-500-v1.woff') format('woff');font-weight:500;}@font-face{font-family:'Museo-Sans';font-display:swap;src:url('https://assets.reastatic.net/common/museo-sans-700-v1.woff2') format('woff2'),url('https://assets.reastatic.net/common/museo-sans-700-v2.woff') format('woff');font-weight:700;}body{font-family:'Museo-Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-weight:300;}"]);
var PreloadLinks = function PreloadLinks() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    href: "https://assets.reastatic.net/common/museo-sans-300-v1.woff2",
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    href: "https://assets.reastatic.net/common/museo-sans-500-v1.woff2",
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    href: "https://assets.reastatic.net/common/museo-sans-700-v1.woff2",
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous"
  }));
};

// Note, technically these <link> tags are only supposed to be in the <head>,
// however browsers still seem to respect it if it's in the body.
// Also, this is only done for the `woff2` versions and any browser that
// doesn't support `woff2` won't support preloading either.

/**
 * Loads MuseoSans font from the CDN
 *
 * @see [MuseoSans documentation](https://construct-kit.reainternal.net/web/museo-sans)
 * */
var MuseoSans = function MuseoSans(_ref) {
  var renderPreloadLinks = _ref.renderPreloadLinks;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderPreloadLinks && /*#__PURE__*/React.createElement(PreloadLinks, null), /*#__PURE__*/React.createElement(GlobalStyle, null));
};
MuseoSans.displayName = "MuseoSans";
MuseoSans.propTypes = {
  /** Controls whether of not to preload the fonts */
  renderPreloadLinks: PropTypes.bool
};
MuseoSans.defaultProps = {
  renderPreloadLinks: true
};
export default MuseoSans;